// extracted by mini-css-extract-plugin
module.exports = {"shortcutdisplay":"ShortcutDisplay-styles-module--shortcutdisplay--318pA"};